(function () {
if (window.trspUploadPreviewLoaded) return;
window.trspUploadPreviewLoaded = true;
function sync(form) {
 var checkbox = form.querySelector('[data-upload-confirmation]');
 var button = form.querySelector('[data-upload-confirmation-button]');
 if (!checkbox || !button) return;
 var file = form.querySelector('input[type="file"]');
 button.disabled = !checkbox.checked || !file || !file.files.length || file.dataset.previewReady !== 'true';
}
function guard(event) {
 var button = event.type === 'click' && event.target.closest('[data-add-to-cart]');
 var form = event.type === 'click' ? button && button.closest('form') : event.target;
 if (!form || !form.querySelector) return;
 var checkbox = form.querySelector('[data-upload-confirmation]');
 if (!checkbox) return;
 form.removeAttribute('novalidate');
 var file = form.querySelector('input[type="file"]');
 if (checkbox.checked && file && file.files.length && file.dataset.previewReady === 'true') return;
 event.preventDefault(); event.stopImmediatePropagation();
 if (!checkbox.checked) { checkbox.reportValidity(); checkbox.focus(); }
 else if (file) { file.reportValidity(); file.focus(); }
}
window.addEventListener('click', guard, true);
window.addEventListener('submit', guard, true);
document.addEventListener('change', function (event) {
 var input = event.target, form = input.closest('form');
 if (!form || !form.querySelector('[data-upload-confirmation]')) return;
 if (input.matches('[data-upload-confirmation]')) { sync(form); return; }
 if (!input.matches('input[type="file"]')) return;
 form.querySelector('[data-upload-confirmation]').checked = false;
 input.dataset.previewReady = 'false'; input.setCustomValidity(''); sync(form);
 var panel = form.querySelector('[data-upload-preview]');
 var image = panel.querySelector('[data-upload-thumbnail]');
 var dimensions = panel.querySelector('[data-upload-dimensions]');
 var message = panel.querySelector('[data-upload-message]');
 if (input.dataset.previewUrl) { URL.revokeObjectURL(input.dataset.previewUrl); delete input.dataset.previewUrl; }
 image.hidden = true; image.removeAttribute('src'); dimensions.textContent = ''; message.textContent = ''; message.className = '';
 var file = input.files[0]; panel.hidden = !file; if (!file) return;
 function fail() {
  if (input.files[0] !== file) return;
  image.hidden = true; input.setCustomValidity(panel.dataset.error);
  message.textContent = panel.dataset.error; message.className = 'upload-warning'; sync(form);
 }
 if (!/\.(jpe?g|png)$/i.test(file.name) || (file.type && !/^image\/(jpeg|png)$/.test(file.type))) { fail(); return; }
 var url = URL.createObjectURL(file); input.dataset.previewUrl = url;
 var probe = new Image();
 probe.onload = function () {
  if (input.files[0] !== file) return;
  image.src = url; image.hidden = false;
  dimensions.textContent = probe.naturalWidth + ' × ' + probe.naturalHeight + ' px';
  if (Math.min(probe.naturalWidth, probe.naturalHeight) < 1500) { message.textContent = panel.dataset.warning; message.className = 'upload-warning'; }
  input.dataset.previewReady = 'true'; sync(form);
 };
 probe.onerror = fail; probe.src = url;
});
document.addEventListener('change', function (event) {
 if (!event.target.matches('select')) return;
 var form = event.target.closest('form'); if (form) setTimeout(function () { sync(form); }, 0);
});
})();
